import { useParams } from 'react-router-dom';
import Map, {
  AttributionControl,
  Layer,
  NavigationControl,
  ScaleControl,
  FullscreenControl,
  Source,
} from 'react-map-gl/mapbox';
import 'mapbox-gl/dist/mapbox-gl.css';
import { Expression } from 'mapbox-gl';
import MapOverlay from '@components/map-selected-overlay';

interface MapSelectedProps {
  latitude: number;
  longitude: number;
  nutsId: string;
  destination: string;
  country: string;
}
// TODO: use a nuts only layer with countries.  We fetch the results again!
function MapSelected({ latitude, longitude, nutsId, destination, country }: MapSelectedProps) {
  const { tripProfileId } = useParams();

  const layerColor: Expression = [
    'case',
    ['==', ['get', 'nuts_id'], nutsId],
    'red',
    'WhiteSmoke',
    // '#ededed',
  ];

  return (
    <Map
      mapboxAccessToken={`${import.meta.env.MAPBOX_TOKEN}`}
      initialViewState={{
        latitude,
        longitude,
        zoom: 7,
      }}
      scrollZoom={false}
      style={{ height: 'calc(100vh - 375px', width: '100%' }}
      mapStyle="mapbox://styles/mapbox/streets-v12"
      projection={{ name: 'mercator' }}
      styleDiffing
      attributionControl={false}
    >
      <NavigationControl />
      <ScaleControl />
      <FullscreenControl />
      <AttributionControl customAttribution="© Global Thematic Insights, LLC " />

      <Source
        id="result-map"
        type="vector"
        url={`${import.meta.env.MVT_BASE_URL}/results-map?trip_profile_id=${tripProfileId}`}
      >
        <Layer
          id="result-map-layer"
          type="fill"
          source-layer="gis_composite_maps_ranked"
          paint={{
            'fill-color': layerColor,
            'fill-outline-color': 'black',
            'fill-opacity': 0.15,
          }}
        />
      </Source>
      {/* <Legend /> */}
      <MapOverlay destination={destination} country={country} />
    </Map>
  );
}

export default MapSelected;
